// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LabOrdersModule-module__font-s-10___fDQqz {
  font-size: 10px !important;
}

.LabOrdersModule-module__font-s-12___Ihi8W {
  font-size: 12px !important;
}

.LabOrdersModule-module__font-s-13___A5Lyb {
  font-size: 13px !important;
}

.LabOrdersModule-module__font-s-14___pfRjq {
  font-size: 14px !important;
}

.LabOrdersModule-module__font-s-15___Uha7L {
  font-size: 15px !important;
}

.LabOrdersModule-module__font-s-16___rCbF8 {
  font-size: 16px !important;
}

.LabOrdersModule-module__font-s-18___UY5__ {
  font-size: 18px !important;
}

.LabOrdersModule-module__font-s-20___evEjR {
  font-size: 20px !important;
}

.LabOrdersModule-module__font-s-22___fq03G {
  font-size: 22px !important;
}

.LabOrdersModule-module__font-s-28___n4LTx {
  font-size: 28px !important;
}

.LabOrdersModule-module__font-w-400___HTfci {
  font-weight: 400 !important;
}

.LabOrdersModule-module__font-w-500___AorNU {
  font-weight: 500 !important;
}

.LabOrdersModule-module__font-w-600___TAIBt {
  font-weight: 600 !important;
}

.LabOrdersModule-module__font-w-700___sWRsQ {
  font-weight: 700 !important;
}

.LabOrdersModule-module__p-5____xzWD {
  padding: 5px !important;
}

.LabOrdersModule-module__p-12___nIiAI {
  padding: 12px !important;
}

.LabOrdersModule-module__p-16___NtDsE {
  padding: 16px !important;
}

.LabOrdersModule-module__p-30___GZrxb {
  padding: 30px !important;
}

.LabOrdersModule-module__p-b-0___Acw5D {
  padding-bottom: 0 !important;
}

.LabOrdersModule-module__p-b-5___u8d8E {
  padding-bottom: 5px !important;
}

.LabOrdersModule-module__p-b-10___eR2q7 {
  padding-bottom: 10px !important;
}

.LabOrdersModule-module__p-b-12___ebQiO {
  padding-bottom: 12px !important;
}

.LabOrdersModule-module__p-b-16___r5yIC {
  padding-bottom: 16px !important;
}

.LabOrdersModule-module__p-b-18___TsZP8 {
  padding-bottom: 18px !important;
}

.LabOrdersModule-module__p-b-20___XaSoY {
  padding-bottom: 20px !important;
}

.LabOrdersModule-module__p-b-25___JWFfw {
  padding-bottom: 25px !important;
}

.LabOrdersModule-module__p-b-30___bI0Si {
  padding-bottom: 30px !important;
}

.LabOrdersModule-module__p-b-50___chzBM {
  padding-bottom: 50px !important;
}

.LabOrdersModule-module__p-t-0___QkNz1 {
  padding-top: 0 !important;
}

.LabOrdersModule-module__p-t-12___EHmZB {
  padding-top: 12px !important;
}

.LabOrdersModule-module__p-t-16___k4lFE {
  padding-top: 16px !important;
}

.LabOrdersModule-module__p-t-18___jFfAu {
  padding-top: 18px !important;
}

.LabOrdersModule-module__p-t-20___umVO2 {
  padding-top: 20px !important;
}

.LabOrdersModule-module__p-t-30___y_Bko {
  padding-top: 30px !important;
}

.LabOrdersModule-module__p-t-40___hoFS3 {
  padding-top: 40px !important;
}

.LabOrdersModule-module__p-t-50___EhU7S {
  padding-top: 50px !important;
}

.LabOrdersModule-module__p-l-20___p8vjo {
  padding-left: 20px !important;
}

.LabOrdersModule-module__p-l-30___rhrao {
  padding-left: 30px !important;
}

.LabOrdersModule-module__p-l-40___UFYlg {
  padding-left: 40px !important;
}

.LabOrdersModule-module__p-r-16___d0Hz9 {
  padding-right: 16px !important;
}

.LabOrdersModule-module__p-r-20___YZQXP {
  padding-right: 20px !important;
}

.LabOrdersModule-module__p-r-30____xjZk {
  padding-right: 30px !important;
}

.LabOrdersModule-module__p-r-50___rx7Wc {
  padding-right: 50px !important;
}

.LabOrdersModule-module__p-r-60___JyrMh {
  padding-right: 60px !important;
}

.LabOrdersModule-module__m-b-1___mwJM1 {
  margin-bottom: 1px !important;
}

.LabOrdersModule-module__m-b-2___ZrEKT {
  margin-bottom: 2px !important;
}

.LabOrdersModule-module__m-b-6___i8yM_ {
  margin-bottom: 6px !important;
}

.LabOrdersModule-module__m-b-8___pcLJq {
  margin-bottom: 8px !important;
}

.LabOrdersModule-module__m-b-10___Z4thL {
  margin-bottom: 10px !important;
}

.LabOrdersModule-module__m-b-14___MUF9B {
  margin-bottom: 14px !important;
}

.LabOrdersModule-module__m-b-16____MDq6 {
  margin-bottom: 16px !important;
}

.LabOrdersModule-module__m-b-20___JWYFb {
  margin-bottom: 20px !important;
}

.LabOrdersModule-module__m-b-22___uGe7z {
  margin-bottom: 22px !important;
}

.LabOrdersModule-module__m-b-24___DrnpA {
  margin-bottom: 24px !important;
}

.LabOrdersModule-module__m-b-30___VzX93 {
  margin-bottom: 30px !important;
}

.LabOrdersModule-module__m-b-32___bLoz3 {
  margin-bottom: 32px !important;
}

.LabOrdersModule-module__m-b-40___wxO4I {
  margin-bottom: 40px !important;
}

.LabOrdersModule-module__m-t-2___cI5Zs {
  margin-top: 2px !important;
}

.LabOrdersModule-module__m-t-3___lsHiD {
  margin-top: 3px !important;
}

.LabOrdersModule-module__m-t-4___kxiDS {
  margin-top: 4px !important;
}

.LabOrdersModule-module__m-t-5___UQf9Z {
  margin-top: 5px !important;
}

.LabOrdersModule-module__m-t-8___AWLZI {
  margin-top: 8px !important;
}

.LabOrdersModule-module__m-t-10___WXaso {
  margin-top: 10px !important;
}

.LabOrdersModule-module__m-t-15___cQK7n {
  margin-top: 15px !important;
}

.LabOrdersModule-module__m-t-16___jIQM5 {
  margin-top: 16px !important;
}

.LabOrdersModule-module__m-t-20___pKk8F {
  margin-top: 20px !important;
}

.LabOrdersModule-module__m-t-22___WenUp {
  margin-top: 22px !important;
}

.LabOrdersModule-module__m-t-30___I_KGa {
  margin-top: 30px !important;
}

.LabOrdersModule-module__m-t-32___U3R4g {
  margin-top: 32px !important;
}

.LabOrdersModule-module__m-l-auto___G6vCM {
  margin-left: auto !important;
}

.LabOrdersModule-module__m-l-4___I5KAY {
  margin-left: 4px !important;
}

.LabOrdersModule-module__m-l-5___zUmMK {
  margin-left: 5px !important;
}

.LabOrdersModule-module__m-l-6___AZdMA {
  margin-left: 6px !important;
}

.LabOrdersModule-module__m-l-8____qKG6 {
  margin-left: 8px !important;
}

.LabOrdersModule-module__m-l-10___ui2ik {
  margin-left: 10px !important;
}

.LabOrdersModule-module__m-l-16___Joqrd {
  margin-left: 16px !important;
}

.LabOrdersModule-module__m-l-20___lblo2 {
  margin-left: 20px !important;
}

.LabOrdersModule-module__m-l-24___rlZwA {
  margin-left: 24px !important;
}

.LabOrdersModule-module__m-l-30___Z6BDn {
  margin-left: 30px !important;
}

.LabOrdersModule-module__m-l-35___ugKfS {
  margin-left: 35px !important;
}

.LabOrdersModule-module__m-l-40___AEMDM {
  margin-left: 40px !important;
}

.LabOrdersModule-module__m-r-8___vgfgu {
  margin-right: 8px !important;
}

.LabOrdersModule-module__m-r-10___ZLJ1F {
  margin-right: 10px !important;
}

.LabOrdersModule-module__m-r-16___IzWg9 {
  margin-right: 16px !important;
}

.LabOrdersModule-module__m-r-20___DY60C {
  margin-right: 20px !important;
}

.LabOrdersModule-module__m-r-24___Njyn6 {
  margin-right: 24px !important;
}

.LabOrdersModule-module__m-r-30___JWBpL {
  margin-right: 30px !important;
}

.LabOrdersModule-module__m-r-40___WR21E {
  margin-right: 40px !important;
}

.LabOrdersModule-module__border-r-3___Swot7 {
  border-radius: 3px !important;
}

.LabOrdersModule-module__border-r-4___fkZXJ {
  border-radius: 4px !important;
}

.LabOrdersModule-module__border-r-6___GVkLh {
  border-radius: 6px !important;
}

.LabOrdersModule-module__border-r-10___Q8Hkw {
  border-radius: 10px !important;
}

.LabOrdersModule-module__border-r-12___uPMQb {
  border-radius: 12px !important;
}

.LabOrdersModule-module__border-r-16___UTRS2 {
  border-radius: 16px !important;
}

.LabOrdersModule-module__border-r-50___LaXKD {
  border-radius: 50% !important;
}

.LabOrdersModule-module__primary-border___ZTVhP {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.LabOrdersModule-module__primary-border-b___uqIBp {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.LabOrdersModule-module__primary-border-t___HIbUY {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.LabOrdersModule-module__primary-border-l____lb8_ {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.LabOrdersModule-module__primary-border-r___Oirju {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.LabOrdersModule-module__secondary-border___w7OIN {
  border: 1px solid #637768;
}

.LabOrdersModule-module__secondary-border-b___dRZcP {
  border-bottom: 1px solid #637768;
}

.LabOrdersModule-module__secondary-border-t___Sn8MW {
  border-top: 1px solid #637768;
}

.LabOrdersModule-module__secondary-border-l___fVchl {
  border-left: 1px solid #637768;
}

.LabOrdersModule-module__secondary-border-r___FMzAg {
  border-right: 1px solid #637768;
}

.LabOrdersModule-module__gap-0___VYwc5 {
  gap: 0 !important;
}

.LabOrdersModule-module__gap-2___CCR2M {
  gap: 2px !important;
}

.LabOrdersModule-module__gap-4___gLeKm {
  gap: 4px !important;
}

.LabOrdersModule-module__gap-5___qn12L {
  gap: 5px !important;
}

.LabOrdersModule-module__gap-6___syj_J {
  gap: 6px !important;
}

.LabOrdersModule-module__gap-8___yhKMO {
  gap: 8px !important;
}

.LabOrdersModule-module__gap-10___amnzR {
  gap: 10px !important;
}

.LabOrdersModule-module__gap-12___Mi8lJ {
  gap: 12px !important;
}

.LabOrdersModule-module__gap-14___x3aJy {
  gap: 14px !important;
}

.LabOrdersModule-module__gap-16___YyT0T {
  gap: 16px !important;
}

.LabOrdersModule-module__gap-18___VH9yN {
  gap: 18px !important;
}

.LabOrdersModule-module__gap-20___C19AC {
  gap: 20px !important;
}

.LabOrdersModule-module__gap-24___PzVWi {
  gap: 24px !important;
}

.LabOrdersModule-module__gap-26___dOerv {
  gap: 26px !important;
}

.LabOrdersModule-module__gap-30___oJrp3 {
  gap: 30px !important;
}

.LabOrdersModule-module__gap-32___U6jgv {
  gap: 32px !important;
}

.LabOrdersModule-module__gap-40___EPaTe {
  gap: 40px !important;
}

.LabOrdersModule-module__gap-50___sRrOW {
  gap: 50px !important;
}

.LabOrdersModule-module__flex-1___lgAR0 {
  flex: 1;
}

.LabOrdersModule-module__flex-none___TuSrn {
  flex: none !important;
}

.LabOrdersModule-module__flex-column___mvw0G {
  display: flex;
  flex-direction: column !important;
}

.LabOrdersModule-module__flex-row___o9idu {
  display: flex;
  flex-direction: row !important;
}

.LabOrdersModule-module__vertically-centered___pYzDC {
  display: flex;
  align-items: center !important;
}

.LabOrdersModule-module__horizontally-centered___Ytny_ {
  display: flex;
  justify-content: center !important;
}

.LabOrdersModule-module__horizontally-end___yYaYe {
  display: flex;
  justify-content: end !important;
}

.LabOrdersModule-module__vertically-start___muLrM {
  display: flex;
  align-items: start !important;
}

.LabOrdersModule-module__space-between___Y9w5B {
  display: flex;
  justify-content: space-between !important;
}

.LabOrdersModule-module__flex-wrap___EotTs {
  flex-wrap: wrap !important;
}

.LabOrdersModule-module__height-100___PoyFs {
  height: 100%;
}

.LabOrdersModule-module__width-50___ub5Zx {
  width: 50% !important;
}

.LabOrdersModule-module__width-100___h6cge {
  width: 100%;
}

.LabOrdersModule-module__cursor-pointer___CV4aF {
  cursor: pointer;
}

.LabOrdersModule-module__cursor-not-allowed___T1_iI {
  cursor: not-allowed !important;
}

.LabOrdersModule-module__absolute-centered____YC8Y {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.LabOrdersModule-module__absolute___Lz0By {
  position: absolute;
}

.LabOrdersModule-module__relative___NaZRO {
  position: relative;
}

.LabOrdersModule-module__fixed___muGl3 {
  position: fixed;
}

.LabOrdersModule-module__visible___eAZ1Q {
  opacity: 1;
}

.LabOrdersModule-module__invisible___TFkdg {
  opacity: 0;
}

.LabOrdersModule-module__col-90___NGXvR {
  width: 90% !important;
}

.LabOrdersModule-module__col-auto___rBK9R {
  width: auto !important;
}

.LabOrdersModule-module__medical-tabs___Lq38M {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.LabOrdersModule-module__medical-table-new___Mc7Ss {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.LabOrdersModule-module__medical-table-new___Mc7Ss:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.LabOrdersModule-module__medical-table-new___Mc7Ss::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.LabOrdersModule-module__medical-table-new___Mc7Ss::-webkit-scrollbar-track {
  display: none;
}
.LabOrdersModule-module__medical-table-new___Mc7Ss.LabOrdersModule-module__no-pagination___cb1Ig {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.LabOrdersModule-module__medical-table-new___Mc7Ss.LabOrdersModule-module__no-pagination___cb1Ig:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.LabOrdersModule-module__medical-table-new___Mc7Ss.LabOrdersModule-module__no-pagination___cb1Ig::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.LabOrdersModule-module__medical-table-new___Mc7Ss.LabOrdersModule-module__no-pagination___cb1Ig::-webkit-scrollbar-track {
  display: none;
}

.LabOrdersModule-module__medical-table-empty___GxfAq {
  padding: 14px 40px !important;
}

.LabOrdersModule-module__icon-btn___ZnoBe {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.LabOrdersModule-module__search-icon___LDNhp {
  width: 24px;
  height: 24px;
  align-self: center;
}

.LabOrdersModule-module__disable-select____cNPt {
  user-select: none;
}

.LabOrdersModule-module__break-word___vsWAj {
  word-break: break-word;
}

.LabOrdersModule-module__popup-clear-btn___PMtu1 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.LabOrdersModule-module__scroll-m-b-20___rMoN7 {
  scroll-margin-bottom: 20px;
}

.LabOrdersModule-module__container___sqd4y {
  color: #375844;
  margin-bottom: -6px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/modules/LabOrdersModule/LabOrdersModule.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,mBAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  color: get-color(greenNew, dark);\n  margin-bottom: -6px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `LabOrdersModule-module__font-s-10___fDQqz`,
	"fontS12": `LabOrdersModule-module__font-s-12___Ihi8W`,
	"fontS13": `LabOrdersModule-module__font-s-13___A5Lyb`,
	"fontS14": `LabOrdersModule-module__font-s-14___pfRjq`,
	"fontS15": `LabOrdersModule-module__font-s-15___Uha7L`,
	"fontS16": `LabOrdersModule-module__font-s-16___rCbF8`,
	"fontS18": `LabOrdersModule-module__font-s-18___UY5__`,
	"fontS20": `LabOrdersModule-module__font-s-20___evEjR`,
	"fontS22": `LabOrdersModule-module__font-s-22___fq03G`,
	"fontS28": `LabOrdersModule-module__font-s-28___n4LTx`,
	"fontW400": `LabOrdersModule-module__font-w-400___HTfci`,
	"fontW500": `LabOrdersModule-module__font-w-500___AorNU`,
	"fontW600": `LabOrdersModule-module__font-w-600___TAIBt`,
	"fontW700": `LabOrdersModule-module__font-w-700___sWRsQ`,
	"p5": `LabOrdersModule-module__p-5____xzWD`,
	"p12": `LabOrdersModule-module__p-12___nIiAI`,
	"p16": `LabOrdersModule-module__p-16___NtDsE`,
	"p30": `LabOrdersModule-module__p-30___GZrxb`,
	"pB0": `LabOrdersModule-module__p-b-0___Acw5D`,
	"pB5": `LabOrdersModule-module__p-b-5___u8d8E`,
	"pB10": `LabOrdersModule-module__p-b-10___eR2q7`,
	"pB12": `LabOrdersModule-module__p-b-12___ebQiO`,
	"pB16": `LabOrdersModule-module__p-b-16___r5yIC`,
	"pB18": `LabOrdersModule-module__p-b-18___TsZP8`,
	"pB20": `LabOrdersModule-module__p-b-20___XaSoY`,
	"pB25": `LabOrdersModule-module__p-b-25___JWFfw`,
	"pB30": `LabOrdersModule-module__p-b-30___bI0Si`,
	"pB50": `LabOrdersModule-module__p-b-50___chzBM`,
	"pT0": `LabOrdersModule-module__p-t-0___QkNz1`,
	"pT12": `LabOrdersModule-module__p-t-12___EHmZB`,
	"pT16": `LabOrdersModule-module__p-t-16___k4lFE`,
	"pT18": `LabOrdersModule-module__p-t-18___jFfAu`,
	"pT20": `LabOrdersModule-module__p-t-20___umVO2`,
	"pT30": `LabOrdersModule-module__p-t-30___y_Bko`,
	"pT40": `LabOrdersModule-module__p-t-40___hoFS3`,
	"pT50": `LabOrdersModule-module__p-t-50___EhU7S`,
	"pL20": `LabOrdersModule-module__p-l-20___p8vjo`,
	"pL30": `LabOrdersModule-module__p-l-30___rhrao`,
	"pL40": `LabOrdersModule-module__p-l-40___UFYlg`,
	"pR16": `LabOrdersModule-module__p-r-16___d0Hz9`,
	"pR20": `LabOrdersModule-module__p-r-20___YZQXP`,
	"pR30": `LabOrdersModule-module__p-r-30____xjZk`,
	"pR50": `LabOrdersModule-module__p-r-50___rx7Wc`,
	"pR60": `LabOrdersModule-module__p-r-60___JyrMh`,
	"mB1": `LabOrdersModule-module__m-b-1___mwJM1`,
	"mB2": `LabOrdersModule-module__m-b-2___ZrEKT`,
	"mB6": `LabOrdersModule-module__m-b-6___i8yM_`,
	"mB8": `LabOrdersModule-module__m-b-8___pcLJq`,
	"mB10": `LabOrdersModule-module__m-b-10___Z4thL`,
	"mB14": `LabOrdersModule-module__m-b-14___MUF9B`,
	"mB16": `LabOrdersModule-module__m-b-16____MDq6`,
	"mB20": `LabOrdersModule-module__m-b-20___JWYFb`,
	"mB22": `LabOrdersModule-module__m-b-22___uGe7z`,
	"mB24": `LabOrdersModule-module__m-b-24___DrnpA`,
	"mB30": `LabOrdersModule-module__m-b-30___VzX93`,
	"mB32": `LabOrdersModule-module__m-b-32___bLoz3`,
	"mB40": `LabOrdersModule-module__m-b-40___wxO4I`,
	"mT2": `LabOrdersModule-module__m-t-2___cI5Zs`,
	"mT3": `LabOrdersModule-module__m-t-3___lsHiD`,
	"mT4": `LabOrdersModule-module__m-t-4___kxiDS`,
	"mT5": `LabOrdersModule-module__m-t-5___UQf9Z`,
	"mT8": `LabOrdersModule-module__m-t-8___AWLZI`,
	"mT10": `LabOrdersModule-module__m-t-10___WXaso`,
	"mT15": `LabOrdersModule-module__m-t-15___cQK7n`,
	"mT16": `LabOrdersModule-module__m-t-16___jIQM5`,
	"mT20": `LabOrdersModule-module__m-t-20___pKk8F`,
	"mT22": `LabOrdersModule-module__m-t-22___WenUp`,
	"mT30": `LabOrdersModule-module__m-t-30___I_KGa`,
	"mT32": `LabOrdersModule-module__m-t-32___U3R4g`,
	"mLAuto": `LabOrdersModule-module__m-l-auto___G6vCM`,
	"mL4": `LabOrdersModule-module__m-l-4___I5KAY`,
	"mL5": `LabOrdersModule-module__m-l-5___zUmMK`,
	"mL6": `LabOrdersModule-module__m-l-6___AZdMA`,
	"mL8": `LabOrdersModule-module__m-l-8____qKG6`,
	"mL10": `LabOrdersModule-module__m-l-10___ui2ik`,
	"mL16": `LabOrdersModule-module__m-l-16___Joqrd`,
	"mL20": `LabOrdersModule-module__m-l-20___lblo2`,
	"mL24": `LabOrdersModule-module__m-l-24___rlZwA`,
	"mL30": `LabOrdersModule-module__m-l-30___Z6BDn`,
	"mL35": `LabOrdersModule-module__m-l-35___ugKfS`,
	"mL40": `LabOrdersModule-module__m-l-40___AEMDM`,
	"mR8": `LabOrdersModule-module__m-r-8___vgfgu`,
	"mR10": `LabOrdersModule-module__m-r-10___ZLJ1F`,
	"mR16": `LabOrdersModule-module__m-r-16___IzWg9`,
	"mR20": `LabOrdersModule-module__m-r-20___DY60C`,
	"mR24": `LabOrdersModule-module__m-r-24___Njyn6`,
	"mR30": `LabOrdersModule-module__m-r-30___JWBpL`,
	"mR40": `LabOrdersModule-module__m-r-40___WR21E`,
	"borderR3": `LabOrdersModule-module__border-r-3___Swot7`,
	"borderR4": `LabOrdersModule-module__border-r-4___fkZXJ`,
	"borderR6": `LabOrdersModule-module__border-r-6___GVkLh`,
	"borderR10": `LabOrdersModule-module__border-r-10___Q8Hkw`,
	"borderR12": `LabOrdersModule-module__border-r-12___uPMQb`,
	"borderR16": `LabOrdersModule-module__border-r-16___UTRS2`,
	"borderR50": `LabOrdersModule-module__border-r-50___LaXKD`,
	"primaryBorder": `LabOrdersModule-module__primary-border___ZTVhP`,
	"primaryBorderB": `LabOrdersModule-module__primary-border-b___uqIBp`,
	"primaryBorderT": `LabOrdersModule-module__primary-border-t___HIbUY`,
	"primaryBorderL": `LabOrdersModule-module__primary-border-l____lb8_`,
	"primaryBorderR": `LabOrdersModule-module__primary-border-r___Oirju`,
	"secondaryBorder": `LabOrdersModule-module__secondary-border___w7OIN`,
	"secondaryBorderB": `LabOrdersModule-module__secondary-border-b___dRZcP`,
	"secondaryBorderT": `LabOrdersModule-module__secondary-border-t___Sn8MW`,
	"secondaryBorderL": `LabOrdersModule-module__secondary-border-l___fVchl`,
	"secondaryBorderR": `LabOrdersModule-module__secondary-border-r___FMzAg`,
	"gap0": `LabOrdersModule-module__gap-0___VYwc5`,
	"gap2": `LabOrdersModule-module__gap-2___CCR2M`,
	"gap4": `LabOrdersModule-module__gap-4___gLeKm`,
	"gap5": `LabOrdersModule-module__gap-5___qn12L`,
	"gap6": `LabOrdersModule-module__gap-6___syj_J`,
	"gap8": `LabOrdersModule-module__gap-8___yhKMO`,
	"gap10": `LabOrdersModule-module__gap-10___amnzR`,
	"gap12": `LabOrdersModule-module__gap-12___Mi8lJ`,
	"gap14": `LabOrdersModule-module__gap-14___x3aJy`,
	"gap16": `LabOrdersModule-module__gap-16___YyT0T`,
	"gap18": `LabOrdersModule-module__gap-18___VH9yN`,
	"gap20": `LabOrdersModule-module__gap-20___C19AC`,
	"gap24": `LabOrdersModule-module__gap-24___PzVWi`,
	"gap26": `LabOrdersModule-module__gap-26___dOerv`,
	"gap30": `LabOrdersModule-module__gap-30___oJrp3`,
	"gap32": `LabOrdersModule-module__gap-32___U6jgv`,
	"gap40": `LabOrdersModule-module__gap-40___EPaTe`,
	"gap50": `LabOrdersModule-module__gap-50___sRrOW`,
	"flex1": `LabOrdersModule-module__flex-1___lgAR0`,
	"flexNone": `LabOrdersModule-module__flex-none___TuSrn`,
	"flexColumn": `LabOrdersModule-module__flex-column___mvw0G`,
	"flexRow": `LabOrdersModule-module__flex-row___o9idu`,
	"verticallyCentered": `LabOrdersModule-module__vertically-centered___pYzDC`,
	"horizontallyCentered": `LabOrdersModule-module__horizontally-centered___Ytny_`,
	"horizontallyEnd": `LabOrdersModule-module__horizontally-end___yYaYe`,
	"verticallyStart": `LabOrdersModule-module__vertically-start___muLrM`,
	"spaceBetween": `LabOrdersModule-module__space-between___Y9w5B`,
	"flexWrap": `LabOrdersModule-module__flex-wrap___EotTs`,
	"height100": `LabOrdersModule-module__height-100___PoyFs`,
	"width50": `LabOrdersModule-module__width-50___ub5Zx`,
	"width100": `LabOrdersModule-module__width-100___h6cge`,
	"cursorPointer": `LabOrdersModule-module__cursor-pointer___CV4aF`,
	"cursorNotAllowed": `LabOrdersModule-module__cursor-not-allowed___T1_iI`,
	"absoluteCentered": `LabOrdersModule-module__absolute-centered____YC8Y`,
	"absolute": `LabOrdersModule-module__absolute___Lz0By`,
	"relative": `LabOrdersModule-module__relative___NaZRO`,
	"fixed": `LabOrdersModule-module__fixed___muGl3`,
	"visible": `LabOrdersModule-module__visible___eAZ1Q`,
	"invisible": `LabOrdersModule-module__invisible___TFkdg`,
	"col90": `LabOrdersModule-module__col-90___NGXvR`,
	"colAuto": `LabOrdersModule-module__col-auto___rBK9R`,
	"medicalTabs": `LabOrdersModule-module__medical-tabs___Lq38M`,
	"medicalTableNew": `LabOrdersModule-module__medical-table-new___Mc7Ss`,
	"noPagination": `LabOrdersModule-module__no-pagination___cb1Ig`,
	"medicalTableEmpty": `LabOrdersModule-module__medical-table-empty___GxfAq`,
	"iconBtn": `LabOrdersModule-module__icon-btn___ZnoBe`,
	"searchIcon": `LabOrdersModule-module__search-icon___LDNhp`,
	"disableSelect": `LabOrdersModule-module__disable-select____cNPt`,
	"breakWord": `LabOrdersModule-module__break-word___vsWAj`,
	"popupClearBtn": `LabOrdersModule-module__popup-clear-btn___PMtu1`,
	"scrollMB20": `LabOrdersModule-module__scroll-m-b-20___rMoN7`,
	"container": `LabOrdersModule-module__container___sqd4y`
};
module.exports = ___CSS_LOADER_EXPORT___;
